import axios from 'axios'
import config from '../config/config'
import router from '@/router'
const serverRoot = config.serverRoot
var ajax = axios.create({
    baseURL: config.serverRoot,
    timeout: 600000
})
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.withCredentials = true
    // Add a request interceptor
ajax.interceptors.request.use(function(config) {
    config.url = config.url.replace(serverRoot + '@/', '')
    if (config.url && config.url.startsWith('/sizheng-api/')) {
        config.url = config.url
        config.baseURL = '/'
    }
    return config
}, function(error) {
    // Do something with request error
    return Promise.reject(error)
})

let filters = [
    // 登录拦截
    function(response) {
        if (response.data && response.data.status && response.data.status === 2) {
            let reg = /share/
            if (!reg.test(window.location.hash)) {
                router.replace('/login')
            }
        }
        return response
    }
]

let filter = function(response) {
    let result = response
    for (let index = 0; index < filters.length; index++) {
        const _filter = filters[index]
        result = _filter(response)
        if (result == null) {
            return result
        }
    }
    return result
}

// Add a response interceptor
ajax.interceptors.response.use(filter, function(error) {
    // if (error.message.includes('code 401')) {
    //     router.replace('/login')
    //     return
    // }
    return Promise.reject(error)
})
export default ajax



// WEBPACK FOOTER //
// ./src/http/index.js